import Page from "../components/common/page";
import Reveal from "../components/common/reveal";
import { AWARD, CREDENTIALS, PRESS, SOCIETIES } from "../data/recognition";

const Recognition = () => (
	<Page page="recognition" className="wrap page">
		<div className="kicker">Recognition</div>
		<h1 className="h-page" style={{ maxWidth: "22ch" }}>
			Elected, awarded, and written about
		</h1>

		<Reveal className="blk-sm">
			<div className="underlined-label">
				Societies and standards bodies
			</div>
			<div className="hair-grid" style={{ marginTop: "1px" }}>
				{SOCIETIES.map((society) => (
					<a
						key={society.name}
						href={society.link}
						target="_blank"
						rel="noreferrer"
						className="hair-cell-tight"
					>
						<img
							src={process.env.PUBLIC_URL + society.logo}
							alt={society.alt}
							style={{
								width: "60px",
								height: "auto",
								flexShrink: 0,
							}}
						/>
						<div>
							<div className="society-role">{society.role}</div>
							<div className="society-name">{society.name}</div>
						</div>
					</a>
				))}
			</div>
		</Reveal>

		<Reveal
			className="blk"
			style={{
				display: "flex",
				flexWrap: "wrap",
				gap: "clamp(32px, 6vw, 88px)",
			}}
		>
			<div style={{ flex: "1 1 300px", minWidth: 0 }}>
				<div className="underlined-label">Award</div>
				<div
					style={{
						paddingTop: "26px",
						display: "flex",
						gap: "22px",
						alignItems: "flex-start",
					}}
				>
					<img
						src={process.env.PUBLIC_URL + AWARD.logo}
						alt={AWARD.alt}
						style={{ width: "76px", height: "auto", flexShrink: 0 }}
					/>
					<div>
						<div
							style={{
								fontFamily: "Newsreader, serif",
								fontSize: "clamp(24px, 2.4vw, 30px)",
								fontWeight: 400,
								lineHeight: 1.2,
								letterSpacing: "-0.018em",
								color: "var(--fg)",
							}}
						>
							{AWARD.title}
						</div>
						<div
							style={{
								fontSize: "15.5px",
								lineHeight: 1.65,
								color: "var(--sec)",
								marginTop: "8px",
							}}
						>
							{AWARD.description}
						</div>
						<a
							href={AWARD.link}
							target="_blank"
							rel="noreferrer"
							className="link-plain"
							style={{
								display: "inline-block",
								borderBottom: "1px solid var(--rule)",
								marginTop: "14px",
							}}
						>
							{AWARD.linkText}
						</a>
					</div>
				</div>
			</div>

			<div style={{ flex: "1 1 380px", minWidth: 0 }}>
				<div className="underlined-label">In the press</div>
				{PRESS.map((item) => (
					<a
						key={item.publication}
						href={item.link}
						target="_blank"
						rel="noreferrer"
						className="rule-bottom-soft"
						style={{
							display: "flex",
							gap: "22px",
							padding: "22px 0",
							textDecoration: "none",
							alignItems: "center",
						}}
					>
						{item.logo ? (
							<img
								src={process.env.PUBLIC_URL + item.logo}
								alt={item.publication}
								style={{
									width: "88px",
									height: "auto",
									flexShrink: 0,
								}}
							/>
						) : (
							<div
								className="mono"
								style={{
									width: "88px",
									flexShrink: 0,
									fontSize: "10px",
									letterSpacing: "0.1em",
									textTransform: "uppercase",
									color: "var(--dim)",
									lineHeight: 1.4,
								}}
							>
								{item.wordmark[0]}
								<br />
								{item.wordmark[1]}
							</div>
						)}
						<div className="press-title">{item.title}</div>
					</a>
				))}
			</div>
		</Reveal>

		<Reveal className="blk">
			<div className="underlined-label">Certification and education</div>
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: "clamp(28px, 5vw, 72px)",
					paddingTop: "28px",
				}}
			>
				{CREDENTIALS.map((item) => (
					<div key={item.heading} style={{ flex: item.basis }}>
						<div className="cred-h">{item.heading}</div>
						<div className="cred-p">{item.body}</div>
					</div>
				))}
			</div>
		</Reveal>
	</Page>
);

export default Recognition;
